/** Minecart Switchyard's first-run walkthrough on level 1: the steps and what each one accepts. */
import type { WalkthroughStep } from '@ka/ui';

/** Level 1: one lapis cart; its only switch starts pointing at the redstone depot. */
export const WALK_LEVEL = 'first-switch';
export const WALK_SWITCH = 'S1';

export interface MinecartWalkthroughHost {
  yard: () => Element | null | undefined;
  sw: () => Element | null | undefined;
  run: () => Element | null | undefined;
  /** The result sheet, or the yard while the carts roll. */
  result: () => Element | null | undefined;
}

export function minecartSteps(h: MinecartWalkthroughHost): WalkthroughStep[] {
  return [
    {
      id: 'goal',
      say: 'Get the cart to its depot',
      hint: 'The cart says ◆ L. It wants the ◆ L depot.',
      target: h.yard,
      button: 'Got it',
    },
    {
      id: 'switch',
      say: 'Tap the switch',
      hint: 'Then the gold rails go down to the L depot.',
      target: h.sw,
    },
    { id: 'run', say: 'Press Run', hint: 'Watch the cart roll.', target: h.run },
    {
      id: 'result',
      say: 'Your cart got home!',
      hint: 'Now try the next puzzle.',
      target: h.result,
      button: 'Done',
    },
  ];
}

/** Whether tapping switch `id` belongs to step `step`. */
export const walkSwitchOk = (step: string | null, id: string) =>
  step === 'switch' && id === WALK_SWITCH;
